import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import ErrorAlert from 'components/ui/ErrorAlert';
import { withTranslation } from 'react-i18next';
import { getSignedUrl } from '../../../../utils/DocumentsAPIUtils';

const maxSize = 2000000;

const acceptedFileTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/pdf',
  'image/jpeg',
  'image/png',
  '.eml',
  '.msg',
  'message/rfc822',
  'application/vnd.ms-outlook',
];

class DocumentUpload extends Component {
  static propTypes = {
    onDrop: PropTypes.func.isRequired,
    uploadPending: PropTypes.bool.isRequired,
    uploadedFileUrl: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      rejectedFiles: [],
      uploadedFileUrl: '',
      documentUrl: '',
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.uploadedFileUrl &&
      this.state.uploadedFileUrl !== nextProps.uploadedFileUrl
    ) {
      this.getSignedUrl(nextProps);
    }
  }

  getSignedUrl = async (nextProps) => {
    try {
      const { data, errors } = await getSignedUrl(nextProps.uploadedFileUrl);

      const signedUrl = data?.getSignedUrl?.signedUrl;

      this.setState({
        documentUrl: signedUrl,
        uploadedFileUrl: nextProps.uploadedFileUrl,
      });
    } catch (e) {
      console.error('DocumentUpload, failed to get signed URL: ', e);
    }
  };
  handleAcceptDrop = (files) => this.props.onDrop(files);
  handleRejectDrop = (files) => {
    this.setState(
      {
        rejectedFiles: files.map((f) => f.name),
      },
      () => {
        setTimeout(() => {
          this.setState({ rejectedFiles: [] });
        }, 4000);
      },
    );
  };

  renderErrors() {
    if (!this.state.rejectedFiles || this.state.rejectedFiles.length === 0) {
      return null;
    }
    const { t } = this.props;
    return (
      <ErrorAlert title={t('MAX_FILE_SIZE_EXCEED')}>
        <ul>
          {this.state.rejectedFiles.map((name) => (
            <li>{name}</li>
          ))}
        </ul>
      </ErrorAlert>
    );
  }

  renderDropzone() {
    const { uploadedFileUrl } = this.props;

    if (uploadedFileUrl) {
      return null;
    }

    const className = classnames(
      'flex',
      'justify-center',
      'items-center',
      'w-full',
      'h-full',
      'border',
      'block',
      'border-dashed',
      'p-4',
      'dropzone-wrapper',
    );
    const { t, dropZoneClassNames } = this.props;
    return (
      <Dropzone
        accept={acceptedFileTypes.join(',')}
        className={`${className} ${dropZoneClassNames}`}
        onDropAccepted={this.handleAcceptDrop}
        onDropRejected={this.handleRejectDrop}
        maxSize={maxSize}
      >
        {this.props.uploadPending && (
          <div className="flex items-center">
            <i className="fa fa-spinner fa-spin" />
            <span>{t('UPLOADING')}</span>
          </div>
        )}
        {!this.props.uploadPending && (
          <p className="block">{t('DROP_DOCUMENT_TO_ADD')}</p>
        )}
      </Dropzone>
    );
  }

  renderUploadedFile() {
    const { uploadedFileUrl } = this.props;

    if (!uploadedFileUrl) {
      return null;
    }

    const documentUrl = this.state.documentUrl;
    return (
      <a
        className="flex items-center"
        href={documentUrl}
        target="_blank"
        rel="noreferrer"
      >
        <i className="fa fa-file-image-o fa-3x" />
      </a>
    );
  }

  render() {
    return (
      <fieldset className="">
        <div className="block mb-4">
          {this.renderDropzone()}
          {this.renderUploadedFile()}
        </div>
        {this.renderErrors()}
      </fieldset>
    );
  }
}

export default withTranslation()(DocumentUpload);
